import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    error: null,
    overlayLoading: false,
};

const baseSlice = createSlice({
    name: 'base',
    initialState,
    reducers: {
        setOverlayLoading: (state, action) => {
            state.loading = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        clearError: (state) => {
            state.error = null;
        },
    },
});

export const { setLoading, setError, clearError, setOverlayLoading } = baseSlice.actions;
export default baseSlice.reducer;